export default __webpack_public_path__ + "static/media/fi-free-delivery-48.a91d7916.svg";